var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.massaged_groups)?_c('div',{style:(_vm.canvas_width)},_vm._l((_vm.massaged_groups),function(massaged_group){return _c('span',{style:(massaged_group.style)},[_vm._v(_vm._s(massaged_group.label))])}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }